import { fetchData } from "@client";
import { mapKeysToCamelCase } from "@client/api/utils/fetchApiUtils";

export async function getProjectDetailsQuery(uuid) {
  try {
    const { results } = await fetchData(`/project/${uuid}`);
    return results;
  } catch (error) {
    if (error?.response?.status === 403 && error?.response?.data?.error?.code === "PROJECT_ACCESS_DENIED") {
      const customError = new Error("PROJECT_ACCESS_DENIED");
      const data = mapKeysToCamelCase(error.response.data)
      customError.code = "PROJECT_ACCESS_DENIED";
      customError.projectUuid = data.error.projectUuid;
      customError.projectName = data.error.projectName;
      customError.ownerEmail = data.error.ownerEmail;
      customError.message = data.error.message;
      throw customError;
    }
    // Obsługa 400 Project not exist
    if (
      error?.response?.status === 400 &&
      (error?.response?.data?.error === "Project not exist" ||
        error?.response?.data?.message === "Project not exist")
    ) {
      const customError = new Error("PROJECT_NOT_FOUND");
      customError.code = "PROJECT_NOT_FOUND";
      throw customError;
    }
    throw error;
  }
}
